import { LISTS_CONSTANTS } from './constants'
import * as rest from '../../services'
export const getLists = (list_name) => {
  return (dispatch) => {
    dispatch({ type: LISTS_CONSTANTS.GET_LISTS_REQUEST })
    return new rest.ListService()
      .makeGetRequest({ list_name: list_name, page_size: 1000 })
      .then((response) => {
        const data = {
          [list_name.toLowerCase()]: response.results,
        }
        dispatch({ type: LISTS_CONSTANTS.GET_LISTS_SUCCESS, response: data })
      })
      .catch((errors) => {
        let data = {
          [list_name.toLowerCase()]: errors,
        }
        dispatch({ type: LISTS_CONSTANTS.GET_LISTS_FAILURE, errors, data })
      })
  }
}


export const getMultipleLists = (list_names) => {
  return (dispatch) => {
    dispatch({ type: LISTS_CONSTANTS.GET_LISTS_REQUEST })
    let str = `${new rest.ListService().url}?`
    list_names.map((e,i)=>{
        str = str+`list_name=${e}&`
    })

      rest.ListService.call_url_action(str,"GET",{page_size: 1000}).then((response) => {
        const data = {}
        list_names.map((e,i)=>{
        data[e.toLowerCase()] = response?.results.filter(x=>x.list_name===e)
        })
        dispatch({ type: LISTS_CONSTANTS.GET_LISTS_SUCCESS, response: data })
      })
      .catch((errors) => {
        let data = {
          "tmp": errors,
        }
        dispatch({ type: LISTS_CONSTANTS.GET_LISTS_FAILURE, errors, data })
      })
  }
}

export const getUserRoles = () => {
  return (dispatch) => {
    dispatch({ type: LISTS_CONSTANTS.GET_LISTS_REQUEST })
    return rest.UserService.call_url_action(
      `users/available_user_roles/`,
      'GET'
    )
      .then((response) => {
        const data = {
          user_roles: response,
        }
        dispatch({ type: LISTS_CONSTANTS.GET_LISTS_SUCCESS, response: data })
      })
      .catch((errors) => {
        let data = {
          user_roles: errors,
        }
        dispatch({ type: LISTS_CONSTANTS.GET_LISTS_FAILURE, errors, data })
      })
  }
}

export const getListTypes = () => {
  return (dispatch) => {
    dispatch({ type: LISTS_CONSTANTS.GET_LISTS_REQUEST })
    return new rest.ListService()
      .getListTypes()
      .then((response) => {
        const data = {
          list_types: response,
        }
        dispatch({ type: LISTS_CONSTANTS.GET_LISTS_SUCCESS, response: data })
      })
      .catch((errors) => {
        let data = {
          list_types: errors,
        }
        dispatch({ type: LISTS_CONSTANTS.GET_LISTS_FAILURE, errors, data })
      })
  }
}
